<!-- Modal -->
<div id="recuperar">
    <div class="modal-content ">
        <div class="modal-header mt-5 border-0">
          <h3 class="modal-title text-center m-auto" id="recuperarLabel" style="color:#00008b">Editar categoría del hotel</h3>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <i class="bi-x modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></i>
        </div>
        <div class="modal-body">
          <div class="row ">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">              
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login mb-4">
                  <div class="form-control">
                      <p class="mb-1">Categoría del hotel</p>
                      <input type="text" formControlName="categoria" class="w-100" (keypress)="keypressValue($event)">
                      <div *ngIf="submitted && f.categoria.errors" class="text-danger">
                        <div *ngIf="f.categoria.errors.required">Categoría de hotel es requerida.</div>
                        <div *ngIf="f.categoria.errors.rangoCategoria">Categoría de hotel no es válida</div>
                      </div>
                  </div>
                  <div class="form-control text-center mt-4">
                    <button type="submit" class="align-self-center border-2 btn btn-lg btn-outline-primary btn-reservar rounded-pill text-center">Aceptar</button>
                    
                  </div>
              </form>
            </div>
            <div class="col-lg-2"></div>
          </div>
        </div>
        <div class="modal-footer mb-5 border-0">
          <img src="assets/images/body/bg-login-2.svg" class="d-none d-lg-block" alt="">
        
        </div>
      </div>   
  </div>
